import styled from 'styled-components';
import { TextStroke } from '../../components/TextStroke';

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 60px;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	width: 620px;
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #ffffff;
	opacity: 0.1;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 20px;
`;

const StyledRewardContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 15px;
`;

const StyledRewardRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	.currency-icon {
		filter: drop-shadow(1px 0 0 rgba(0, 0, 0, 0.25))
			drop-shadow(0 1px 0 rgba(0, 0, 0, 0.25))
			drop-shadow(-1px 0 0 rgba(0, 0, 0, 0.25))
			drop-shadow(0 -1px 0 rgba(0, 0, 0, 0.25));
	}
`;

const StyledMoneyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${TextStroke} {
		font-size: 18px;
		font-weight: 500;
	}
`;

export {
	StyledButtonsContainer,
	StyledContainer,
	StyledDivider,
	StyledMoneyContainer,
	StyledRewardContainer,
	StyledRewardRightContainer,
};
